import axios from "axios";

// export const baseUrl = "https://app1.crazzyhub.com/";
// export const baseUrl = "http://192.168.1.71:9098/";
// export const baseUrl = "http://122.163.177.178:4545/";
export const baseUrl = "https://crazylab.appvedas.com/";
// export const baseUrl = "http://192.168.20.63:4545/"


// const baseURL =
//   process.env.NODE_ENV === "production" ? baseUrl : baseUrlLocal;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Token");
    config.headers = {
      Authorization: token,
      Token: token,
      ...config.headers,
    };
    return config;
  },
  (err) => Promise.reject(err)
);

export default axiosInstance;
